(ns frontend.view.curtains.webentry-resolution.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:webentry-resolution-curtain]))
(defonce session db/session)
(defonce tenant db/tenant)
(defonce role db/role)
(defonce tasks (r/cursor db/app-state [:views :tasks-grid]))

(defn clear! []
  (reset! state nil))
